import { useContext } from 'react'

import { SeminarAppContext } from './SeminarAppContext'

export const useSeminarAppContext = () => useContext(SeminarAppContext)
